import { NavBar, Toast, Form, Button } from 'antd-mobile';
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { matchApi } from '../../features/match/api/matchApi';


export default function FirstTeam() {

    const navigate = useNavigate()
    const location = useLocation();
    const gameId = location.state?.gameId;

    useEffect(() => {
        // 路由 state 在刷新后可能丢失，缺少比赛 ID 时安全返回首页。
        if (!gameId) {
            Toast.show({ icon: 'fail', content: '缺少比赛信息，请重新进入' })
            navigate('/home', { replace: true })
            return undefined
        }

        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        let active = true

        matchApi.getDetail(gameId)
            .then(function (response) {
                const result = response.data.data
                if (!active) return
                // 当前页面只允许已进入对应阶段的比赛访问。
                if (result.statusInfo !== 1) {
                    navigate('/home')
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
                if (active) Toast.clear()
            });

        // 页面离开后忽略异步结果，避免卸载组件继续更新状态。
        return () => {
            active = false
            Toast.clear()
        }
    }, [gameId, navigate]);


    return (
        <div className="applicate-container has-unified-nav ui-page ui-page--with-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                选择阵型
            </NavBar>
            <div className='body_detail ui-page__content'>
                <Form
                    layout='horizontal'
                    footer={
                        <Button block type='submit' color='primary' size='large'>
                            提交
                        </Button>
                    }
                >
                    <Form.Item name='type' label='选择阵型'>

                    </Form.Item>
                </Form >
            </div>
        </div>
    )
}
